import type { ReactNode } from 'react'

import { StyledAnimatedGroup } from './AnimatedImageGroup.Styled'

const AnimatedImageGroup = ({ children }: { children?: ReactNode }) => {
  return <StyledAnimatedGroup>{children}</StyledAnimatedGroup>
}

export default AnimatedImageGroup
